import { EngineDataTypeEnum } from 'src/types/BusinessModel/AolEnums';
import { EngineDataBM } from '../types/BusinessModel/EngineDataBM';
import { EngineData } from '../types/ViewModel/EngineData';
import { roundTo2Decimals } from '../utils/numberHelper';

export class EngineDataFactory {
    private isEmptyValue = (data) => !data || (Object.keys(data).length === 0 && Object.getPrototypeOf(data) === Object.prototype);

    public create(data: EngineDataBM): EngineData {
        if (data === null || data === undefined) {
            return null;
        }
        return new EngineData(
            roundTo2Decimals(data.runningHours),
            data.powerOutput,
            data.powerLoggedOutput,
            data.pitch,
            data.revolutionsPerMinute,
            data.consumptionHfo,
            data.consumptionMgo,
            data.type,
            data?.engineNumber ? data.engineNumber : null
        );
    }

    public createBM(data: EngineData): EngineDataBM {
        if (data === null || data === undefined) {
            return null;
        }
        return {
            runningHours: roundTo2Decimals(data.runningHours),
            powerOutput: data.powerOutput,
            powerLoggedOutput: data.powerLoggedOutput,
            pitch: data.pitch,
            revolutionsPerMinute: data.revolutionsPerMinute,
            consumptionHfo: data.consumptionHfo,
            consumptionMgo: data.consumptionMgo,
            type: data.type as EngineDataTypeEnum,
            engineNumber: data?.engineNumber ? data.engineNumber : undefined,
        };
    }

    public createList(data: EngineDataBM[]): EngineData[] {
        if (!data) return [];
        return data.filter((h) => !this.isEmptyValue(h) && h.runningHours !== null && h.runningHours !== undefined).map((h) => this.create(h));
    }

    public createBMList(data: EngineData[]): EngineDataBM[] {
        if (!data) return [];
        return data.map((e) => this.createBM(e));
    }
}
